<template>
  <div class="container-fluid mt--7">
    <a-drawer width="480" placement="right" @close="onClose" :visible="visible">
      <h6 class="heading-small text-muted mb-4" v-if="btnValue == -1">Add Product Exclusion</h6>
      <h6 class="heading-small text-muted mb-4" v-else-if="btnValue == 0">Edit Product Exclusion</h6>
      <h6 class="heading-small text-muted mb-4" v-else-if="btnValue == 1">View Product Exclusion</h6>

      <base-alert v-if="errors.length" type="danger">
        <b>You have the following error(s):</b>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </base-alert>

      <form id="form-proper">
        <base-input label="Site" required>
          <a-select v-model="productExclusion.site_id" :disabled="btnValue == 1 || site_type == 'branch'">
            <a-select-option v-for="site in sites" :key="site.id" :value="site.id">
              {{ site.name }}
            </a-select-option>
          </a-select>
        </base-input>

        <base-input label="Exclude By" required class="d-flex justify-content-between align-items-center">
          <a-radio-group v-model="productExclusion.exclude_by" @change="onExcludeByChange" :disabled="btnValue == 1">
            <a-radio-button value="product">
              Product
            </a-radio-button>
            <a-radio-button value="category">
              Category
            </a-radio-button>
            <a-radio-button value="brand">
              Brand
            </a-radio-button>
          </a-radio-group>
        </base-input>

        <base-input label="Excluded Values" required>
          <a-select v-if="productExclusion.exclude_by == 'product'" v-model="productExclusion.exclude_value" mode="multiple" placeholder="Search products by name" :disabled="btnValue == 1" allowClear show-search @search="handleProductSearch" :filter-option="false" :not-found-content="fetching ? undefined : null">
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="product in products" :key="product.id" :value="product.id">
              {{ product.name }}
            </a-select-option>
          </a-select>

          <a-select v-else-if="productExclusion.exclude_by == 'category'" v-model="productExclusion.exclude_value" mode="multiple" placeholder="Search categories by name" :disabled="btnValue == 1" allowClear>
            <a-select-option v-for="category in categories" :key="category.id" :value="category.id">
              {{ category.name }}
            </a-select-option>
          </a-select>

          <a-select v-else-if="productExclusion.exclude_by == 'brand'" v-model="productExclusion.exclude_value" mode="multiple" placeholder="Search brands by name" :disabled="btnValue == 1" allowClear>
            <a-select-option v-for="brand in brands" :key="brand.id" :value="brand.id">
              {{ brand.name }}
            </a-select-option>
          </a-select>
        </base-input>

        <base-input label="Start Date">
          <a-date-picker v-model="productExclusion.starts_at" show-time :disabled-date="disabledStartDate" allowClear />
        </base-input>

        <base-input label="End Date">
          <a-date-picker v-model="productExclusion.ends_at" show-time :disabled-date="disabledEndDate" allowClear />
        </base-input>
        
        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn btn-success" @click.prevent="create" v-if="btnValue == -1">Save</button>
            <button class="btn btn-success" @click.prevent="update" v-if="btnValue == 0">Save</button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
        </div>
      </form>
    </a-drawer>
    <div class="row">
      <div class="col">
        <div class="mb-3 card" style="/**height: 70vh;*/ overflow: auto;">
          <div class="row no-gutters">
            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
              <div class="card-body">
                <div class="filter-bar ui basic segment grid">
                  <div class="ui form">
                    <div class="inline field">
                      <h6 class="heading-small text-muted mb-4">Filter by Site</h6>
                      <div class="input-group mb-3">
                        <a-select v-model="site_id" showSearch placeholder="Search by site" @change="fetch" optionFilterProp="children" style="width: 100%">
                          <a-select-option v-for="option in sites" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                        </a-select>
                      </div>

                      <hr class="my-4" />
                      <h6 class="heading-small text-muted mb-4">Filter by Exclusion Type</h6>
                      <div>
                        <base-radio name="0" class="mb-3" v-model="filterExcludeBy" value="O">
                          All
                        </base-radio>
                        <base-radio name="product" class="mb-3" v-model="filterExcludeBy" value="product">
                          Product
                        </base-radio>
                        <base-radio name="category" class="mb-3" v-model="filterExcludeBy" value="category">
                          Category
                        </base-radio>                        
                        <base-radio name="brand" class="mb-3" v-model="filterExcludeBy" value="brand">
                          Brand
                        </base-radio>
                      </div>

                      <hr class="my-4" v-if="filterExcludeBy != '0'"/>
                      <h6 class="heading-small text-muted mb-4" v-if="filterExcludeBy != '0'">Filter by {{ filterExcludeBy }}</h6>
                      <a-select v-if="filterExcludeBy == 'product'" v-model="filterExcludeValue" placeholder="Search products by name" allowClear show-search @search="handleProductSearch" :filter-option="false" :not-found-content="fetching ? undefined : null" style="width: 100%">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="product in products" :key="product.id" :value="product.id">
                          {{ product.name }}
                        </a-select-option>
                      </a-select>

                      <a-select v-else-if="filterExcludeBy == 'category'" v-model="filterExcludeValue" placeholder="Search categories by name" allowClear show-search style="width: 100%">
                        <a-select-option v-for="category in categories" :key="category.id" :value="category.id">
                          {{ category.name }}
                        </a-select-option>
                      </a-select>

                      <a-select v-else-if="filterExcludeBy == 'brand'" v-model="filterExcludeValue" placeholder="Search brands by name" allowClear show-search style="width: 100%">
                        <a-select-option v-for="brand in brands" :key="brand.id" :value="brand.id">
                          {{ brand.name }}
                        </a-select-option>
                      </a-select>

                      <hr class="my-4" />
                      <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                      <div>
                        <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                          All
                        </base-radio>
                        <base-radio name="A" class="mb-3" v-model="filterStatus" value="A">
                          Active
                        </base-radio>
                        <base-radio name="I" class="mb-3" v-model="filterStatus" value="I">
                          Inactive
                        </base-radio>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-9">
              <div class="card-body">
                <div class="card shadow">
                  <a-modal title="Warning" :visible="modalVisible" @ok="massupdate('status', 'D')"
                    @cancel="modalVisible = false">
                    All changes to be made cannot be reverted. Are you sure you want to delete the selected products?
                  </a-modal>

                  <div class="card-header border-0">
                    <div class="row align-items-center">
                      <div id="errorNotification" class="col-md-12">
                        <base-alert v-if="errorMessage != null" type="danger">
                          <span class="alert-inner--text"> {{ errorMessage }}</span>
                          <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </base-alert>
                        <base-alert v-if="successMessage != null" type="success">
                          <span class="alert-inner--text"> {{ successMessage }}</span>
                          <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </base-alert>
                      </div>
                      <div class="col-md-3">
                        <h3 class="mb-0">
                          {{ _.startCase(currentProfile) }}
                        </h3>
                      </div>
                      <div class="col-md-9 text-right">
                        <base-dropdown class="nav-link pr-0 float-right" position="right">
                          <div class="media align-items-center" slot="title">
                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                          </div>
                          <template>
                            <div class=" dropdown-header noti-title">
                              <h6 class="text-overflow m-0">ACTIONS</h6>
                            </div>
                            <div class="dropdown-item" @click.prevent="showActionDrawer('config_list')">
                              <i class="ni ni-settings-gear-65"></i>
                              <span>Configuration</span>
                            </div>
                          </template>
                        </base-dropdown>
                        <div v-if="serverType == 'ho'">
                          <div v-if="selectedRowKeys.length == 0 && accessRights.includes('A')">
                            <base-button class="float-right ml-1 mt-1" type="primary" size="sm"
                              @click.prevent="showDrawer(0, -1)">+ Add {{ _.startCase(_.singularize(currentProfile))
                              }}</base-button>
                          </div>
                          <div v-else-if="selectedRowKeys.length > 0 && accessRights.includes('W')">
                            <base-button class="float-right ml-1 mt-1" type="danger" size="sm"
                              @click.prevent="modalVisible = true">Delete Selected</base-button>
                            <base-dropdown class="nav-link" position="right">
                              <div class="media align-items-center" slot="title">
                                <base-button class="float-right ml-1" type="info" size="sm">Change Status</base-button>
                              </div>
                              <template>
                                <div class="dropdown-header noti-title">
                                  <h6 class="text-overflow m-0 text-muted">
                                    Select Status
                                  </h6>
                                </div>
                                <div class="dropdown-item" @click.prevent="massupdate('status', 'A')">
                                  <span>Active</span>
                                </div>
                                <div class="dropdown-item" @click.prevent="massupdate('status', 'I')">
                                  <span>Inactive</span>
                                </div>
                              </template>
                            </base-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <!-- insert hasSelected here -->

                    <a-table size="small" :rowSelection="{
                      selectedRowKeys: selectedRowKeys,
                      onChange: onSelectChange,
                    }" :columns="columns" :dataSource="data" :scroll="scroll" :loading="loading"
                      :rowKey="(record) => record.id" :pagination="pagination" @change="handleTableChange">

                      <template slot="exclude_value_names" slot-scope="exclude_value_names">
                        <a-tag v-for="name in exclude_value_names" :key="name">
                          {{ name }}
                        </a-tag>
                      </template>

                      <template slot="status" slot-scope="status">
                        {{ status | filterStatusOnTableList }}
                      </template>

                      <template slot="action" slot-scope="action">
                        <center>
                          <div v-if="serverType == 'ho'" class="table-button-container">
                            <!-- <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                              @click.prevent="showModal(action)">
                              History
                            </button> -->
                            <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm" @click.prevent="
                              showDrawer(action.id, 1)
                            ">
                              View
                            </button>
                            <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm" @click.prevent="
                              showDrawer(action.id, 0)
                            ">
                              Edit
                            </button>
                            <a-popconfirm title="Are you sure you want to delete this record?" @confirm="deleteRow(action.id)"
                              okText="Delete" cancelText="Cancel" v-if="accessRights.includes('D')">
                              <a class="btn btn-danger btn-sm text-white">Delete</a>
                            </a-popconfirm>
                          </div>
                          <div v-else class="table-button-container">
                            <button class="btn btn-info btn-sm" @click.prevent="
                              showDrawer(action.id, 1)
                            ">
                              View
                            </button>
                            <button class="btn btn-success btn-sm" @click.prevent="showModal(action)">
                              History
                            </button>
                          </div>
                        </center>
                      </template>
                    </a-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js';
import ValidateField from "../../components/validateFormUtils.js"; 
import { mapState, mapActions } from 'vuex'
import reqwest from 'reqwest'
import moment from 'moment';

var component_x;

export default {
  data () {
    this.handleProductSearch = _.debounce(this.handleProductSearch, 800)
    return {
      accessRights: [],
      data: [],
      scroll: { x: 600, y: 800 },
      default_display: 10,
      pagination: {
        pageSize: 10
      },
      productExclusion: {
        site_id: 0,
        exclude_by: "product",
        exclude_value: "",
        starts_at: null,
        ends_at: null,
      },
      sites: [],
      products: [],
      categories: [],
      brands: [],
      site_type: '',
      loading: false,
      fetching: false,
      btnValue: 0,
      visible: false,
      modalVisible: false,
      errors: [],
      errorMessage: null,
      successMessage: null,
      columns: [
        {
          title: "Site",
          dataIndex: "site_name",
          // sorter: (a, b) => a.site_name.localeCompare(b.site_name)
        },
        {
          title: "Exclude By",
          dataIndex: "exclude_by",
          align: "center",
          customRender: value => _.capitalize(value)
        },
        {
          title: "Excluded Values",
          dataIndex: "exclude_value_names",
          width: 400,
          scopedSlots: { customRender: "exclude_value_names" }
        },
        {
          title: "Starts At",
          dataIndex: "starts_at",
          align: "center",
          customRender: value => {
            if (value) {
              return moment(value).format("YYYY-MM-DD HH:mm:ss")
            }
          }
        },
        {
          title: "Ends At",
          dataIndex: "ends_at",
          align: "center",
          customRender: value => {
            if (value) {
              return moment(value).format("YYYY-MM-DD HH:mm:ss")
            }
          }
        },
        {
          title: "Status",
          dataIndex: "status",
          align: "center",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "Actions",
          key: "operation",
          fixed: "right",
          align: "center",
          width: 200,
          scopedSlots: { customRender: "action" },
        },
      ],
      rowSelection: {},
      selectedRowKeys: [],
      params: {},
      lastFetchId: 0,
      site_id: 0,
      filterStatus: '0',
      filterExcludeBy: '0',
      filterExcludeValue: '0'
    }
  },
  filters: {
    filterStatusOnTableList (value) {
      if (value == 'A') {
        return 'Active';
      } else {
        return 'Inactive';
      }
    },
  },
  computed: {
    ...mapState(['currentProfile', 'parameters', 'serverType', 'endPoint', 'profileId', 'validSites'])
  },
  watch:{
    filterStatus: () => {
      component_x.fetch()
    },
    filterExcludeBy: () => {
      component_x.filterExcludeValue = null
      component_x.fetch()
    },
    filterExcludeValue: () => {
      component_x.fetch()
    }
  },
  async mounted () {
    component_x = this;
    this.accessRights = this.$attrs.accessRights
    this.siteType = secureStorage.getItem("currentSiteSiteType")

    if (this.siteType == 'ho') {
      let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites", null)
      this.sites = sites
      this.sites.splice(0, 0, {id: 0, name: 'All Sites'})
    } else {
      this.site_id = secureStorage.getItem("defaultSiteId")
      let sites = await HTTPRequest.getRequest(this.endPoint + "sites/" + this.site_id, null)
      this.sites.push(sites)
    }

    let categories = await HTTPRequest.getRequest(this.endPoint + "categories/get_valid_categories?level=4", null)
    this.categories = categories

    let brands = await HTTPRequest.getRequest(this.endPoint + "brands/get_valid_brands", null)
    this.brands = brands

    this.fetch(this.params)
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters', 'updateProfileId']),
    moment,
    onSelectChange (selectedRowKeys) {
      // console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    handleTableChange (pagination, filters, sorter) {
      filters = this.params;
      var pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = Number(this.default_display);
      this.pagination = pager;
      this.currentPage = pagination.current;
      this.fetch({
        // results: Number(this.default_display),
        page: pagination.current,
        ...filters,
      });
    },
    fetch (params = {}) {
      // console.log('fetch params:', params);
      this.loading = true;
      let additional_product_params = "";
      if (this.site_id > 0) {
        additional_product_params = "&site_id=" + this.site_id;
      }

      if (this.filterStatus != '0') {
        additional_product_params = additional_product_params + "&status=" + this.filterStatus
      }

      if (this.filterExcludeBy != '0') {
        additional_product_params = additional_product_params + "&exclude_by=" + this.filterExcludeBy
      }

      if (this.filterExcludeValue) {
        additional_product_params = additional_product_params + `&${this.filterExcludeBy}_id=` + this.filterExcludeValue
      }

      reqwest({
        url:
          this.endPoint +
          "product_exclusions?per_page=10" +
          additional_product_params,
        method: "get",
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
        },
        data: {
          // results: Number(this.default_display),
          ...params,
        },
      }).then((response) => {
        // console.log("data",response)
        var pagination = { ...this.pagination };
        pagination.total = response.total;
        pagination.pageSize = Number(response.per_page);
        // pagination.current = response.current_page
        var productData = response.data;
        this.data = productData
        this.loading = false;
        this.pagination = pagination;
      });
    },
    async massupdate (field_name, value) {
      var field_update = {};
      this.modalVisible = false;
      field_update[field_name] = value;
      var payload = {
        ids: this.selectedRowKeys,
        field_update: field_update,
      };
      var response = await HTTPRequest.postRequest(
        this.endPoint + "product_exclusions/mass_update",
        null,
        payload
      );
      if (response["message"] == "Ok") {
        this.$notification["success"]({
          message: "Update Successful",
          description: "Mass update of selected product suceeded.",
        });
        this.fetch(this.params);
        this.selectedRowKeys = [];
      } else {
        this.$notification["error"]({
          message: "Update Failed",
          description:
            "Mass update of selected product failed. " + response["error"],
        });
      }
    },
    showDrawer (id, btn) {
      this.productExclusion = {}
      this.products = []
      this.btnValue = btn;
      this.updateProfileId(id);
      if (this.btnValue !== -1) { // view or edit mode 
        let productExclusion = this.data.find(row => row.id == id)
        this.productExclusion = Object.assign({}, productExclusion)

        let temp_array = this.productExclusion.exclude_value.split(',')
        this.productExclusion.exclude_value = temp_array.map(value => parseInt(value))
        this.productExclusion.exclude_value.forEach(async (value) => {
          let product = await HTTPRequest.getRequest(this.endPoint + "products/" + value, null)
          this.products.push({
            id: product.id,
            name: `${product.name} (${product.reference_code})`
          })
        });

      } else if (this.btnValue == -1) { // add mode
        let current_site = secureStorage.getItem("defaultSiteId")
        this.productExclusion = {
          site_id: current_site,
          exclude_by: "product",
          exclude_value: [],
          starts_at: null,
          ends_at: null,
        }
      }

      this.visible = true;
    },
    validateForm () {
      this.errors = []
      this.errors.push(ValidateField.required('Site', this.productExclusion.site_id))
      this.errors.push(ValidateField.required('Exclude By', this.productExclusion.exclude_by))
      this.errors.push(ValidateField.isEmpty('Excluded Value', this.productExclusion.exclude_value))
      if (this.productExclusion.starts_at || this.productExclusion.ends_at) {
        this.errors.push(ValidateField.identicalField('Start Date', 'End Date', this.productExclusion.starts_at, this.productExclusion.ends_at))
      }
      this.errors = this._.compact(this.errors);
      return this.errors.length;
    },
    onClose () {
      this.visible = false;
      this.productExclusion = {
        site_id: null,
        exclude_by: "product",
        exclude_value: [],
        starts_at: null,
        ends_at: null,
      }
      this.errors = []
    },
    onExcludeByChange () {
      this.productExclusion.exclude_value = []
    },
    handleProductSearch (value) {
      this.fetching = true
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;

      fetch(this.endPoint + `products?name=${value}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": 'Bearer ' + secureStorage.getItem("accessToken"), 
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
        }
      }).then(res => res.json())
      .then(res => {
        if (fetchId !== this.lastFetchId) {
          // for fetch callback order
          return;
        }
        this.products = res.data.map(value => {
          return {
            id: value.id,
            name: `${value.name} (${value.reference_code})`
          }
        })
        this.fetching = false
      })
    },
    disabledStartDate(startValue) {
      const endValue = this.productExclusion.ends_at;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.productExclusion.starts_at;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    async create () {
      if (!this.validateForm()) {
        // convert array to comma delimited string
        let excluded_values = this.productExclusion.exclude_value.join(",")
        this.productExclusion.exclude_value = excluded_values

        var payload = { product_exclusion: this.productExclusion }
        var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_exclusions', null, payload)
        if (post_request == undefined) {
          // this.$emit("refreshPage", event);
          this.onClose()
          this.fetch(this.params)
          this.successMessage = "Product Exclusion added successfully"
        } else {
          if (post_request["error"] == undefined) {
            // this.$emit("refreshPage", event);
            this.onClose()
            this.fetch(this.params)
            this.successMessage = "Product Exclusion added successfully"
          } else {
            this.errors = post_request["error"].split(",");
          }
        }
      }
    },
    async update () {
      if (!this.validateForm()) {
        // convert array to comma delimited string
        let excluded_values = this.productExclusion.exclude_value.join(",")
        this.productExclusion.exclude_value = excluded_values

        var payload = { product_exclusion: this.productExclusion }
        var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_exclusions/' + this.profileId, null, payload)
        if (put_request == undefined) {
          // this.$emit("refreshPage", event);
          this.onClose()
          this.fetch(this.params)
          this.successMessage = "Product Exclusion updated successfully"
        } else {
          if (put_request["error"] == undefined) {
            // this.$emit("refreshPage", event);
            this.onClose()
            this.fetch(this.params)
            this.successMessage = "Product Exclusion updated successfully"
          } else {
            this.errors = put_request["error"].split(",");
          }
        }
      }
    },
    async deleteRow (id) {
      let delete_request = await HTTPRequest.destroyRequest(this.endPoint + "product_exclusions/" + id)
      if (delete_request == undefined) {
          // this.$emit("refreshPage", event);
          this.onClose()
          this.fetch(this.params)
          this.successMessage = "Product Exclusion deleted successfully"
        } else {
          if (delete_request["error"] == undefined) {
            // this.$emit("refreshPage", event);
            this.onClose()
            this.fetch(this.params)
            this.successMessage = "Product Exclusion deleted successfully"
          } else {
            this.errors = delete_request["error"].split(",");
          }
        }
    },
    removeMessage(type) {
      if (type == 'error')
        this.errorMessage = null
      else
        this.successMessage = null
    }
  },
};

</script>

<style lang="scss" scoped></style>